import { useMetadataMapper } from '@common/hooks/useMetadataMapper';
import {
    FieldConfig,
    MetadataCard,
    MetadataCardBaseProps,
} from './MetadataCard';

export interface SmartMetadataCardProps<T> extends MetadataCardBaseProps {
    source: T | undefined;
    config: FieldConfig<T>[];
    resolveLabel: (key: keyof T) => string;
}

export const SmartMetadataCard = <T extends object>({
    source,
    config,
    resolveLabel,
    ...rest
}: SmartMetadataCardProps<T>) => {
    const mappedData = useMetadataMapper(source, config, resolveLabel);
    return <MetadataCard data={mappedData} {...rest} />;
};
